export class Contact {
    mobileNumber: string;
    personalEmail: string;
    workEmail: string;
}
